import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const StudentMessages = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("inbox");
  const [showCompose, setShowCompose] = useState(false);

  // Mock messages data
  const messagesData = {
    inbox: [
      {
        id: "1",
        from: "Ms. Johnson",
        fromRole: "Mathematics Teacher",
        subject: "Math Test Feedback",
        message: "Great job on your recent test! Keep up the excellent work.",
        timestamp: "2024-08-20 14:30",
        read: false,
        priority: "normal",
      },
      {
        id: "2",
        from: "Dr. Smith",
        fromRole: "Physics Teacher",
        subject: "Lab Report Clarification",
        message: "Please review the lab report requirements and resubmit.",
        timestamp: "2024-08-20 09:15",
        read: true,
        priority: "high",
      },
      {
        id: "3",
        from: "School Admin",
        fromRole: "Administration",
        subject: "Schedule Change Notice",
        message:
          "Your History class has been moved to Room 302 starting Monday.",
        timestamp: "2024-08-19 16:00",
        read: true,
        priority: "normal",
      },
      {
        id: "4",
        from: "Mr. Davis",
        fromRole: "English Teacher",
        subject: "Essay Assignment",
        message:
          "Your essay topic has been approved. Please proceed with writing.",
        timestamp: "2024-08-19 10:30",
        read: false,
        priority: "normal",
      },
    ],
    sent: [
      {
        id: "5",
        to: "Ms. Johnson",
        toRole: "Mathematics Teacher",
        subject: "Question about Homework",
        message:
          "Could you please clarify problem #15 from yesterday's assignment?",
        timestamp: "2024-08-19 15:45",
        status: "delivered",
      },
      {
        id: "6",
        to: "School Admin",
        toRole: "Administration",
        subject: "Library Card Request",
        message: "I would like to request a new library card as mine was lost.",
        timestamp: "2024-08-18 12:20",
        status: "read",
      },
    ],
  };

  const unreadCount = messagesData.inbox.filter((msg) => !msg.read).length;

  const renderMessageCard = (message: any, type: "inbox" | "sent") => {
    return (
      <div
        key={message.id}
        className={`card mb-3 ${
          type === "inbox" && !message.read ? "border-primary" : ""
        }`}
      >
        <div className="card-body">
          <div className="d-flex align-items-start">
            <div className="avatar avatar-sm bg-primary me-3">
              <i className="ti ti-user text-white"></i>
            </div>
            <div className="flex-fill">
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div>
                  <h6
                    className={`mb-0 ${
                      type === "inbox" && !message.read ? "fw-bold" : ""
                    }`}
                  >
                    {type === "inbox" ? message.from : message.to}
                    {type === "inbox" && !message.read && (
                      <span className="badge bg-primary ms-2">New</span>
                    )}
                  </h6>
                  <small className="text-muted">
                    {type === "inbox" ? message.fromRole : message.toRole}
                  </small>
                </div>
                <div className="text-end">
                  {type === "inbox" && message.priority === "high" && (
                    <span className="badge bg-danger mb-1">High Priority</span>
                  )}
                  {type === "sent" && (
                    <span
                      className={`badge ${
                        message.status === "read" ? "bg-success" : "bg-info"
                      } mb-1`}
                    >
                      {message.status === "read" ? "Read" : "Delivered"}
                    </span>
                  )}
                  <br />
                  <small className="text-muted">
                    {new Date(message.timestamp).toLocaleDateString()}
                  </small>
                </div>
              </div>
              <h6 className="mb-2">{message.subject}</h6>
              <p className="text-muted mb-0">{message.message}</p>
              <div className="d-flex gap-2 mt-3">
                <button className="btn btn-primary btn-sm">
                  <i className="ti ti-eye me-1"></i>
                  View
                </button>
                <button className="btn btn-outline-primary btn-sm">
                  <i className="ti ti-corner-up-left me-1"></i>
                  Reply
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={routes.studentDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Messages</li>
                </ul>
              </div>
            </div>
          </div>

          {/* Page Title */}
          <div className="row">
            <div className="col-12">
              <div className="card bg-primary">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-white">
                      <h3>Messages</h3>
                      <p>Communicate with teachers and administration</p>
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      <button
                        className="btn btn-light"
                        onClick={() => setShowCompose(true)}
                      >
                        <i className="ti ti-plus me-2"></i>
                        Compose
                      </button>
                      <div className="avatar avatar-lg position-relative">
                        <i className="ti ti-message text-white fs-1"></i>
                        {unreadCount > 0 && (
                          <span className="badge bg-danger position-absolute top-0 end-0">
                            {unreadCount}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary Cards */}
          <div className="row">
            <div className="col-sm-6 col-lg-4">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-primary-transparent mb-3">
                    <i className="ti ti-inbox fs-2 text-primary"></i>
                  </div>
                  <h4 className="text-primary">{messagesData.inbox.length}</h4>
                  <p className="mb-0">Inbox Messages</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-danger-transparent mb-3">
                    <i className="ti ti-bell-ringing fs-2 text-danger"></i>
                  </div>
                  <h4 className="text-danger">{unreadCount}</h4>
                  <p className="mb-0">Unread</p>
                </div>
              </div>
            </div>
            <div className="col-sm-6 col-lg-4">
              <div className="card">
                <div className="card-body text-center">
                  <div className="avatar avatar-lg bg-success-transparent mb-3">
                    <i className="ti ti-send fs-2 text-success"></i>
                  </div>
                  <h4 className="text-success">{messagesData.sent.length}</h4>
                  <p className="mb-0">Sent Messages</p>
                </div>
              </div>
            </div>
          </div>

          {/* Messages Content */}
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <ul className="nav nav-tabs card-header-tabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "inbox" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("inbox")}
                      >
                        <i className="ti ti-inbox me-2"></i>
                        Inbox ({messagesData.inbox.length})
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "sent" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("sent")}
                      >
                        <i className="ti ti-send me-2"></i>
                        Sent ({messagesData.sent.length})
                      </button>
                    </li>
                  </ul>
                </div>
                <div className="card-body">
                  {activeTab === "inbox" && (
                    <div>
                      {messagesData.inbox.length > 0 ? (
                        messagesData.inbox.map((message) =>
                          renderMessageCard(message, "inbox")
                        )
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-inbox-off fs-2 text-muted"></i>
                          </div>
                          <h5>No messages in inbox</h5>
                          <p className="text-muted">
                            New messages will appear here.
                          </p>
                        </div>
                      )}
                    </div>
                  )}

                  {activeTab === "sent" && (
                    <div>
                      {messagesData.sent.length > 0 ? (
                        messagesData.sent.map((message) =>
                          renderMessageCard(message, "sent")
                        )
                      ) : (
                        <div className="text-center py-4">
                          <div className="avatar avatar-lg bg-light mb-3">
                            <i className="ti ti-send-off fs-2 text-muted"></i>
                          </div>
                          <h5>No sent messages</h5>
                          <p className="text-muted">
                            Your sent messages will appear here.
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Compose Modal */}
      {showCompose && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Compose Message</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowCompose(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="form-label">To:</label>
                  <select className="form-select">
                    <option>Select recipient...</option>
                    <option>Ms. Johnson - Mathematics Teacher</option>
                    <option>Dr. Smith - Physics Teacher</option>
                    <option>Mr. Davis - English Teacher</option>
                    <option>School Administration</option>
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Subject:</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter subject..."
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Message:</label>
                  <textarea
                    className="form-control"
                    rows={5}
                    placeholder="Type your message..."
                  ></textarea>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowCompose(false)}
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary">
                  <i className="ti ti-send me-2"></i>
                  Send Message
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StudentMessages;
